import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import Page from '../components/Page';
import SingleImageSection from '../components/SingleImageSection';
import HeroSection from '../components/HeroSection';
import InfoColumnSection from '../components/InfoColumnSection';
import ActionColumnSection from '../components/ActionColumnSection';
import variables from '../styles/variables.module.scss';
import SingleTextSection from '../components/SingleTextSection';
import CasesSliderSection from '../components/CasesSliderSection';
import { landingPage } from '../data';
import heroimg from '../assets/images/landingpage-hero-min.jpg';
import extraimg1 from '../assets/images/landingpage-extraimg1-min2.jpg';
import FriendsSection from '../components/FriendsSection';

const hero = { fall: heroimg };
const office = { fall: extraimg1 };

const LandingPage = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          businessMail
          careerMail
        }
      }
    }
  `);
  const {
    businessMail,
    careerMail,
  } = data.site.siteMetadata;

  return (
    <Page style={{ backgroundColor: variables.tuna }}>
      <HeroSection
        stroke={landingPage.heroStroke}
        strokeColor={variables.cleanWhite}
        headline={landingPage.heroHeadline}
        backgroundColor={variables.tuna}
        image={hero}
      />
      <SingleTextSection>
        {landingPage.singleSectionText}
      </SingleTextSection>
      <ActionColumnSection
        headlineSmall={landingPage.actionColSmall}
        headlineLarge={landingPage.actionColLarge}
        stroke={landingPage.actionColStroke}
        title={landingPage.actionColTitle}
        body={landingPage.actionColBody}
        data={{
          ...landingPage.actionColData,
          firstEmail: businessMail,
          secondEmail: careerMail,
        }}
      />
      <FriendsSection amount={12} />
      <CasesSliderSection />
      {/* <SingleImageSection
        image={office}
        backgroundColor={variables.carbonBlack}
      /> */}
      <InfoColumnSection
        backgroundColor={variables.tuna}
        headlineSmall={landingPage.infoColSmall}
        headlineLarge={landingPage.infoColLarge}
        stroke={landingPage.infoColStroke}
        title={landingPage.infoColTitle}
        body={landingPage.infoColBody}
        data={landingPage.infoColData}
      />
    </Page>
  );
};

export default LandingPage;
